import Vue from "vue";
import {
  getCroppedImageUrl,
  underscoreToSpaces,
  capitalize,
  lowercase,
  formatDate,
} from "~/common/helpers";

export default ({ app }) => {
  function formattedDate(date, options) {
    return formatDate(app.i18n.locale, date, options);
  }

  Vue.filter("formattedDate", formattedDate);
  Vue.filter("getCroppedImageUrl", getCroppedImageUrl);
  Vue.filter("underscoreToSpaces", underscoreToSpaces);
  Vue.filter("capitalize", capitalize);
  Vue.filter("lowercase", lowercase);
};
